/** @jsx jsx */
import {jsx} from 'theme-ui'
import './Loader.css'

type Props = {}

const Loader: React.FC<Props> = () => {
  return (
    <div className="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

export default Loader
